"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatBadgeSet = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@twurple/common");
const ChatBadgeVersion_1 = require("./ChatBadgeVersion");
/**
 * A set of badges.
 */
let ChatBadgeSet = class ChatBadgeSet extends common_1.DataObject {
    /**
     * Names of all versions of the badge set.
     */
    get versionNames() {
        return Object.keys(this[common_1.rawDataSymbol].versions);
    }
    /**
     * Gets a specific version of a badge by name.
     *
     * @param name The name of the version.
     */
    getVersion(name) {
        return new ChatBadgeVersion_1.ChatBadgeVersion(this[common_1.rawDataSymbol].versions[name]);
    }
};
ChatBadgeSet = tslib_1.__decorate([
    (0, common_1.rtfm)('api', 'ChatBadgeSet')
], ChatBadgeSet);
exports.ChatBadgeSet = ChatBadgeSet;
